module.exports = __webpack_public_path__ + "img/tinder.cb82d99.png";